//allows letters,numbers checks @ sign, chars after .(.com,.dk)
export const emailRegexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
// Minimum eight characters, at least one uppercase letter, one lowercase letter and one number:
export const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/i;

export const oneLowerCaseRegexp = /([a-z])+/i;